import { FreeRoundsServiceEvent, IServices } from "@netent/origin";
import { IPlayUIState } from "@netent/playui";
import { ListenerCreator } from "../../types";

const started = (services: IServices) => (
  roundsLeft: number
): IPlayUIState => ({
  freeRounds: {
    enabled: true,
    value: roundsLeft
  },
  bet: {
    enabled: false
  },
  totalWin: {
    valueInCoins: services.freeRounds.getTotalWinCoins(),
    valueInCash: services.freeRounds.getTotalWinCash(),
    denomination: services.bet.getDenomination()
  }
});

const ended = (services: IServices) => (): IPlayUIState => ({
  freeRounds: {
    enabled: false
  },
  bet: {
    enabled: true
  },
  balance: {
    valueInCash: services.money.getBalanceCash(),
    valueInCoins: services.money.getBalanceCoins()
  },
  win: {
    valueInCoins: services.freeRounds.getTotalWinCoins(),
    valueInCash: services.freeRounds.getTotalWinCash(),
    denomination: services.bet.getDenomination()
  }
});

const reInit = (services: IServices) => (): IPlayUIState => ({
  win: {
    valueInCoins: services.win.getTotalWinCoins(),
    valueInCash: services.win.getTotalWinCash()
  },
  totalWin: {
    valueInCoins: services.freeRounds.getTotalWinCoins(),
    valueInCash: services.freeRounds.getTotalWinCash()
  }
});

export const listeners = new Map<FreeRoundsServiceEvent, ListenerCreator>([
  ["started", started],
  ["ended", ended],
  ["reInit", reInit]
]);
